<template lang="html">

  <form role="form" @submit.prevent.stop>
    <autosplit-dialog-modal ref="autosplitModal"></autosplit-dialog-modal>
    <template v-if="model.options.warningNoticeTemp">
      <payout-hint-panel-form-group :warning="true">
        <template>{{ model.options.warningNoticeTemp }}</template>
      </payout-hint-panel-form-group>
      <br/>
    </template>

    <template v-if="model.options?.isFullnameRequired">
      <EpayInputFormGroup :label="$t('ФИО (опционально)')" attribute="fio"
                          :hint="$t('fio_hint')"
                          :placeholder="$t('fio_placeholder')"
                          :model="model"
                          :required="!model.options?.isFullnameRequiredButOptional"/>
    </template>

    <payout-form-group :label="$t('Номер карты')" :required="true"
                       :has-errors="model.errors.has('cardNumber')">
      <filtered-input-wrapper v-model="model.values.cardNumber">
        <payout-cardnumber-input v-model="model.values.cardNumber"></payout-cardnumber-input>
      </filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints
                               :hint="$t('card_number_hint')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="cardNumber|*"
                           :errors="model.errors"></error-message-block>
    </payout-form-group>
    <!--    <template v-if="model.options.isFullnameRequired">-->
    <!--      <payout-textfield-input-group :label="$t('Имя владельца карты')" :required="true" errors-attribute="firstname" :model="model" attribute="firstname"></payout-textfield-input-group>-->
    <!--      <payout-textfield-input-group :label="$t('Фамилия владельца карты')" :required="true" :model="model" attribute="lastname" errors-attribute="lastname"></payout-textfield-input-group>-->
    <!--    </template>-->
    <payout-textfield-input-group :model="model" :label="$t('Назначение')" :required="true"
                                  attribute="description"></payout-textfield-input-group>
    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>
    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>
    <!-- Будет применен курс автоконвертации ({src} = {dest})-->
    <!-- payout-destination-currency-conversion-notice-form-group(:model="model")-->
    <!-- Ожидаемая сумма зачисления-->
    <payout-estimated-destination-amount-form-group
      :model="model"></payout-estimated-destination-amount-form-group>
    <template v-if="model.options.limitsTextHtml">
      <payout-toggable-hint-panel-form-group :heading="$t('Лимиты')"
                                             :link-text="$t('Информация о лимитах')">
        <div v-html="model.options.limitsTextHtml"></div>
      </payout-toggable-hint-panel-form-group>
    </template>

    <PayoutHintPanelFormGroup :warning="true">
      <i18n path="rucards_2card2card_text_0" tag="p" class="warning--text--underlined">
      </i18n>

      <i18n path="rucards_2card2card_text_1" tag="p">
        <template v-slot:card2card>
          <a href="/finance/payout/card2card"
             :title="$t('канал Card2Card')">{{ $t('канал Card2Card') }}</a>
        </template>
      </i18n>
    </PayoutHintPanelFormGroup>

    <payout-form-notification-block :model="model"></payout-form-notification-block>
    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import {Component} from "vue-property-decorator";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {RussianCardsPaymentModel} from "@/components/forms/payout/forms/cards/cards-payments";
import AutosplitDialogModal from "@/views/pages/finance/payout/AutosplitDialogModal.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutCardnumberInput from "@/components/forms/payout/forms/PayoutCardnumberInput.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutDestinationCurrencyConversionNoticeFormGroup
  from "@/components/forms/payout/crypto/PayoutDestinationCurrencyConversionNoticeFormGroup.vue";
import EpayInputFormGroup from "@/components/forms/payout/forms/epay/EpayInputFormGroup.vue";

@Component({
  name: "RussianCardsPaymentForm",
  components: {
    EpayInputFormGroup,
    PayoutDestinationCurrencyConversionNoticeFormGroup,
    PayoutToggableHintPanelFormGroup,
    FilteredInputWrapper,
    PayoutEvaluateFeeFormGroup,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutCardnumberInput,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup,
    ErrorMessageBlock,
    PayoutInputHintBlock, PayoutHintPanelFormGroup, PayoutFormGroup, AutosplitDialogModal
  }
})
export default class RussianCardsPaymentForm extends AbstractPayoutForm {
  model = new RussianCardsPaymentModel()

  get isBeneficiaryRequired() {
    return this.model.options.beneficiaryRequired
  }
}
</script>

<style scoped>
.warning--text--underlined {
  text-decoration: underline;

}
</style>

<i18n>
{
  "ru": {
    "card_number_hint": "Номер карты. Пример: 1234 5678 9012 3456",
    "rucards_2card2card_text_0": "Для сокращения количества отмененных транзакций провайдерами были скорректированы настройки.",
    "rucards_2card2card_text_1": "Часть платежей, совершенных через данный канал, в случае невозможности их обработки, может быть исполнена через {card2card} (выплаты с карты физического лица).",
    "rucards_2card2card_text_2": "В качестве дополнительной меры советуем совершать платежи суммами до {amount} рублей. При необходимости по несколько транзакций одномоментно.",
    "fio_hint": "Имя Фамилия Отчество. Заполнение данного поля не является обязательным, но может заметно ускорить конверсию и время обработки транзакций.",
    "fio_placeholder": "Иван Иванов Иванович"
  },
  "en": {
    "fio_placeholder": "Ivan Ivanov Ivanovich",
    "ФИО (опционально)": "Full name (optional)",
    "fio_hint": "Name Surname Patronymic. Filling in this field is not mandatory, but can significantly speed up conversion and transaction processing time.",
    "rucards_2card2card_text_0": "To reduce the number of transactions canceled by providers, the settings have been adjusted.",
    "rucards_2card2card_text_1": "Part of the payments made through this channel, in case of impossibility of their processing, can be executed through {card2card} (payments from a physical person's card).",
    "rucards_2card2card_text_2": "As an additional measure, we recommend making payments in amounts up to {amount} rubles. If necessary, several transactions at the same time.",
    "Лимиты": "Limits",
    "Информация о лимитах": "Limits information",
    "Номер карты": "Card number",
    "Назначение": "Description",
    "канал Card2Card": "Card2Card channel",
    "Имя владельца карты": "First name",
    "Фамилия владельца карты": "Last name",
    "card_number_hint": "Card number. Example: 1234 5678 1234 5678"
  }
}
</i18n>
